"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "makeFlexSchemaPropTypes", {
  enumerable: true,
  get: function get() {
    return _schema.makeFlexSchemaPropTypes;
  }
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _modifiers = require("../../modifiers");

var _utils = require("../../utils");

var _schema = _interopRequireWildcard(require("./schema"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Flex = _styledComponents.default.div.withConfig({
  displayName: "Flex",
  componentId: "bgi4mi-0"
})(["", ";", ";", ";"], _modifiers.withFlex, _modifiers.withSpacing, (0, _utils.applyDynamicModifiers)('zIndex', 'z-index')); // @ts-ignore


Flex.propTypes = _schema.default.propTypes;
var _default = Flex;
exports.default = _default;